// eslint-disable-next-line import/no-anonymous-default-export
const en = {
  descriptionBold: 'Wir freuen uns über Ihr Interesse.',
  description: 'Suchen und wählen Sie den gewünschten Termin.',
  eventTypeTitles: {
    '': '',
    Youngster: 'Youngster (13 - 16 Jahre)',
	  'Job Info Events': 'Berufsinformation',
	  Visits: 'Besucherführungen',
    'Recruitment Days (1d)': 'Rekrutierungstage (1 T)',
    'Recruitment Days (1d+)': 'Rekrutierungstage (1 T+)',
    Internal: 'Intern',
  },
  noEvents: ' Im Moment sind keine freien Termine verfügbar. Wir schalten demnächst neue Termine auf. Besten Dank für Ihre Geduld.',
  loadError: 'Die Termine konnten im Moment nicht geladen werden. Bitte laden Sie die Seite neu oder versuchen Sie es in einigen Minuten erneut.',
  noGuidedTours: "Wir schalten demnächst neue Termine auf. Besten Dank für Ihre Geduld. In der Zwischenzeit können Sie uns über folgendes Formular kontaktieren: <1>Führung anfragen</1>",
  filters: {
    eventType: 'Art der Veranstaltung ändern',
    startDate: 'Von',
    endDate: 'Bis',
    location: 'Ort',
    languageLabel: 'Sprache',
    language: {
      title: 'Sprache auswählen',
      en: 'Englisch',
      fr: 'Französisch',
      it: 'Italienisch',
      de: 'Deutsch',
    },
    search: 'Suchen',
    clear: 'Zurücksetzen',
  },
  card: {
    startDate: 'Startdatum:',
    startHour: 'Startzeit:',
    endDate: 'Enddatum:',
    endHour: 'Endzeit:',
    until: 'bis',
  },
  contact: 'Kontakt',
  contactDesc: 'Bei Fragen erreichen Sie uns unter 043 931 61 11 oder per E-Mail',
  feast: {
    title: 'Anmeldung zum FEAST-1-Test',
    subtitle:
      'Die FEAST-Tests von Skyguide sind nur auf Einladung verfügbar und erfordern eine vorherige Bewerbung. Falls dies noch nicht erfolgt ist, bewerben Sie sich bitte <1>hier</1> für die entsprechende Ausbildung zur Flugverkehrsleiterin bzw. zum Flugverkehrsleiter.',
    filterTitle: 'Suchen und wählen Sie den gewünschten Termin aus.'
  },
  schoolOfCompetence: {
    title: 'School of Competence',
    subtitle: 'Entdecken Sie die Workshops der skyguide School of Competence und melden Sie sich für den passenden Workshop an.',
    filterTitle: 'Suchen und wählen Sie den gewünschten Termin aus.',
    filterLabel: 'School of Competence',
  },
};

export default en;